export default __webpack_public_path__ + "static/media/SIL Open Font License.0b4e3287.txt";